import "@/util/extends/toFirstUpperCase";
import router from "@/router/index";
import { api } from "@/api/index";
import axios from "axios";

//通用模块状态控制
const middleware = {
  state: {
    orderForm: {},
    RegionList: [],
    dictionarys: {},
  },

  mutations: {
    setOrder(state, data) {
      state.orderForm = data;
    },
    setCustormInfo(state, data) {
      state.custormInfo = data;
    },
    setRegionList(state, data) {
      state.RegionList = data;
    },
    setDictionarys(state, data) {
      state.dictionarys = data;
    },
  },

  actions: {
    getTheAdress({ commit, state }, { ...params }) {
      return new Promise((resolve, reject) => {
        api.order
          .getCacheRegion()
          .then((res) => {
            // console.log("获取用户信息",JSON.parse(JSON.stringify(res)));
            if (res.status) {
              commit("setRegionList", res.data[0].children);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default middleware;



// WEBPACK FOOTER //
// ./src/store/modules/middleware.js